import React, { useCallback, useState } from 'react';

import { Control, Page } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { FaceDetectorPoint3 } from '@vlabs/monokit/shared/ui/face-detector/FaceDetector.point3';

import st from './FaceCreateForm-point3.module.sass';

interface FaceCreateFormPoint3Props {
  onSubmit: (value: { sdkDescriptor: string; sampleId: string }) => void;
  closeModal?: VoidFunction;
}

export function FaceCreateFormPoint3({
  onSubmit,
  closeModal = undefined,
}: FaceCreateFormPoint3Props): React.JSX.Element {
  const { t } = useTranslation();
  const [faceDescriptor, setFaceDescriptor] = useState<{ sdkDescriptor: string; sampleId: string } | null>();

  const isSubmitDisabled = !faceDescriptor;

  const handleFaceDetectorChange = useCallback(
    (value: { sdkDescriptor: string; sampleId: string } | null | undefined) => {
      setFaceDescriptor(value ?? null);
    },
    [],
  );

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (faceDescriptor) {
      onSubmit(faceDescriptor);
      closeModal?.();
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Page
        className={st.Root}
        title={t('monokit:create face modal.forms.title')}
      >
        <FaceDetectorPoint3
          dropzoneClassName={st.Dropzone}
          onChange={handleFaceDetectorChange}
        />
        <div className={st.ModalFooter}>
          <div className={st.ButtonWrapper}>
            <Control.Button
              data-testid="FaceCreateForm.button.submit"
              disabled={isSubmitDisabled}
              fullWidth
              type="submit"
            >
              {t('monokit:create face modal.forms.buttons.submit')}
            </Control.Button>
          </div>
          <div className={st.ButtonWrapper}>
            <Control.Button
              data-testid="FaceCreateForm.button.close modal"
              fullWidth
              kind="secondary"
              onClick={closeModal}
              variant="outlined"
            >
              {t('monokit:create face modal.forms.buttons.cancel')}
            </Control.Button>
          </div>
        </div>
      </Page>
    </form>
  );
}
